module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-container', [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.sections), function(section, index) {
    return (section.page_layout || section.section_layout) ? [_c(section.page_layout || section.section_layout, {
      tag: "component",
      attrs: {
        "first": index === 0,
        "section": section
      }
    })] : _vm._e()
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ce913b4","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/sections/sections.vue
// module id = 674
// module chunks = 0